module.exports = __webpack_public_path__ + "static/media/012-Erkundigen_oV_ID_18.f1281a72.mp3";